import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _TEMPLATE_CATEGORIES$;
import { TEMPLATE_CATEGORIES, TEMPLATE_STATUSES } from './mutation-types';
export default (_TEMPLATE_CATEGORIES$ = {}, _defineProperty(_TEMPLATE_CATEGORIES$, TEMPLATE_CATEGORIES, function (state) {
  return state[TEMPLATE_CATEGORIES];
}), _defineProperty(_TEMPLATE_CATEGORIES$, TEMPLATE_STATUSES, function (state) {
  return state[TEMPLATE_STATUSES];
}), _TEMPLATE_CATEGORIES$);